import type { SxProps, Theme } from "@mui/material";

export const wrapperSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 3,
};

export const sectionLabelSx: SxProps<Theme> = {
  fontSize: "0.7rem",
  fontWeight: 600,
  letterSpacing: "0.1em",
  textTransform: "uppercase",
  color: "text.secondary",
  mb: 1,
};

export const dayGroupSx: SxProps<Theme> = {
  display: "flex",
  gap: 1,
  flexWrap: "wrap",
};

export const dayButtonSx: SxProps<Theme> = {
  width: 44,
  height: 44,
  ml: "-1px !important",
  borderRadius: "10px !important",
  border: "1px solid !important",
  borderColor: "#d0d0d0 !important",
  fontSize: "0.75rem !important",
  fontWeight: "600 !important",
  textTransform: "none !important",
  "&.Mui-selected": {
    backgroundColor: "rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.15)",
    },
  },
};

export const errorTextSx: SxProps<Theme> = {
  fontSize: "0.72rem",
  color: "error.main",
  mt: 0.75,
};

export const timeRowSx: SxProps<Theme> = {
  display: "flex",
  gap: 1.5,
  alignItems: "flex-start",
  mb: 2,
};

export const hourSelectSx: SxProps<Theme> = {
  width: 80,
};

export const minuteSelectSx: SxProps<Theme> = {
  width: 80,
};

export const amPmSelectSx: SxProps<Theme> = {
  width: 90,
};

export const submitButtonSx: SxProps<Theme> = {
  px: 3,
  borderRadius: "4px",
  fontWeight: 500,
  height: 48,
  ml: 2,
  backgroundColor: "#000",
  color: "#fff",
  "&:hover": {
    backgroundColor: "#212121",
  },
};

export const modalActionsSx: SxProps<Theme> = {
  display: "flex",
};

export const modalButtonSx: SxProps<Theme> = {
  ...submitButtonSx,
  ml: "auto",
};
